import { RouterStore } from 'react-router-mobx'

export default new RouterStore()



// WEBPACK FOOTER //
// ./src/App/stores/router.js